export const BRAND_COLOR = '#F169B4';
export const BRAND_ON_PRIMARY = '#ffffff';
export const BRAND_TEXT_COLOR = '#802560';

// Ant Design 6.2 names its default Medium size "middle".
export const buttonThemeTokens = {
  controlHeight: 32,
  controlHeightLG: 32,
  controlHeightSM: 32,
  contentFontSize: 14,
  contentFontSizeLG: 14,
  contentFontSizeSM: 14,
  contentLineHeight: 22 / 14,
  contentLineHeightLG: 22 / 14,
  contentLineHeightSM: 22 / 14,
  paddingInline: 15,
  paddingInlineLG: 15,
  paddingInlineSM: 15,
  paddingBlock: 4,
  paddingBlockLG: 4,
  paddingBlockSM: 4,
  onlyIconSize: 16,
  onlyIconSizeLG: 16,
  onlyIconSizeSM: 16,
  iconGap: 8,
  primaryColor: BRAND_ON_PRIMARY,
  primaryShadow: 'none',
  defaultShadow: 'none',
  dangerShadow: 'none',
};

export const brandThemeTokens = {
  colorPrimary: BRAND_COLOR,
  colorPrimaryHover: '#e05aa4',
  colorPrimaryActive: '#d8539e',
  colorPrimaryBg: '#fff2f8',
  colorPrimaryBgHover: '#fbd2e9',
  colorPrimaryBorder: '#f7a5d2',
  colorPrimaryText: '#a6387c',
  colorPrimaryTextHover: BRAND_TEXT_COLOR,
  colorPrimaryTextActive: '#591945',
  colorInfo: BRAND_COLOR,
};

export const storefrontThemeTokens = {
  ...brandThemeTokens,
  colorTextBase: '#1f2937',
  colorText: '#1f2937',
  colorTextSecondary: '#6b7280',
  colorBgLayout: '#f5f6f8',
  colorBgContainer: '#ffffff',
  colorBgElevated: '#ffffff',
  colorBorder: '#e5e7eb',
  colorBorderSecondary: '#e5e7eb',
  fontSize: 14,
  borderRadius: 8,
  borderRadiusLG: 12,
  borderRadiusXL: 12,
  boxShadow: 'none',
  boxShadowSecondary: 'none',
  fontFamily: "'Noto Sans Khmer', 'Poppins', sans-serif",
};

// Responsive control dimensions are supplied by the shared CSS variables.
export const inputThemeTokens = {
  controlHeight: 40,
  controlHeightLG: 40,
  controlHeightSM: 40,
  inputFontSize: 14,
  inputFontSizeLG: 14,
  inputFontSizeSM: 14,
  borderRadius: 8,
  borderRadiusLG: 8,
  borderRadiusSM: 8,
};
